import {Reducers} from './dataEnum';

/**
 * @enum {String}
 */
export const App = {
  CHANGE_VIEW: [Reducers.APP, 'CHANGE_VIEW'].join('/'),
  SET_ERROR_BOUNDARY: [Reducers.APP, 'SET_ERROR_BOUNDARY'].join('/'),
  SET_VERSION: [Reducers.APP, 'SET_VERSION'].join('/'),
};

/**
 * @enum {String}
 */
export const Loading = {
  SHOW: [Reducers.LOADING, 'SHOW'].join('/'),
  HIDE: [Reducers.LOADING, 'HIDE'].join('/'),
  CHANGE_TEXT: [Reducers.LOADING, 'CHANGE_TEXT'].join('/'),
};

/**
 * @enum {String}
 */
export const SignalR = {
  SET_SESSION_TAKEN_OVER: [Reducers.SIGNALR, 'SET_SESSION_TAKEN_OVER'].join('/'),
  SET_DEVICE_HUB_CONNECTION_STATE: [Reducers.SIGNALR, 'SET_DEVICE_HUB_CONNECTION_STATE'].join('/'),
};

/**
 * @enum {String}
 */
export const Toast = {
  SHOW: [Reducers.TOAST, 'SHOW'].join('/'),
  HIDE: [Reducers.TOAST, 'HIDE'].join('/'),
};

/**
 * @enum {String}
 */
export const Modal = {
  SHOW_GENERIC: [Reducers.MODAL, 'SHOW_GENERIC'].join('/'),
  SHOW: [Reducers.MODAL, 'SHOW'].join('/'),
  HIDE: [Reducers.MODAL, 'HIDE'].join('/'),
  SET_VARIANT: [Reducers.MODAL, 'SET_VARIANT'].join('/'),
  SET_MODE: [Reducers.MODAL, 'SET_MODE'].join('/'),
  SET_HIDE_CLOSE_BUTTON: [Reducers.MODAL, 'SET_HIDE_CLOSE_BUTTON'].join('/'),
  SET_INLINE_MESSAGE: [Reducers.MODAL, 'SET_INLINE_MESSAGE'].join('/'),
  SET_DISABLE_BLUR: [Reducers.MODAL, 'SET_DISABLE_BLUR'].join('/'),
  SET_SIZE: [Reducers.MODAL, 'SET_SIZE'].join('/'),
  SET_IS_MINIMIZED: [Reducers.MODAL, 'SET_IS_MINIMIZED'].join('/'),
};

/**
 * @enum {String}
 */
export const AutoProfile = {
  SET_SHOW_PAUSE_TO_REFILL_MODAL: [Reducers.AUTO_PROFILE, 'SET_SHOW_PAUSE_TO_REFILL_MODAL'].join('/'),
  SET_IS_PAUSE_HANDLED: [Reducers.AUTO_PROFILE, 'SET_IS_PAUSE_HANDLED'].join('/'),
  SET_RUNNING_METHOD: [Reducers.AUTO_PROFILE, 'SET_RUNNING_METHOD'].join('/'),
};

/**
 * @enum {String}
 */
export const Scheduler = {
  SET_SHOW_SCHEDULE_RUN_MODAL: [Reducers.AUTO_PROFILE, 'SET_SHOW_SCHEDULE_RUN_MODAL'].join('/'),
  SET_SCHEDULE_RUN: [Reducers.SCHEDULER, 'SET_SCHEDULE_RUN'].join('/'),
  SET_SCHEDULE_REMINDER: [Reducers.SCHEDULER, 'SET_SCHEDULE_REMINDER'].join('/'),
  SET_SCHEDULE_TYPE: [Reducers.SCHEDULER, 'SET_SCHEDULE_TYPE'].join('/'),
  SET_SCHEDULE_ID: [Reducers.SCHEDULER, 'SET_SCHEDULE_ID'].join('/'),
  SET_START_TIME: [Reducers.SCHEDULER, 'SET_START_TIME'].join('/'),
  SET_DELTA_TIME: [Reducers.SCHEDULER, 'SET_DELTA_TIME'].join('/'),
  RESET: [Reducers.SCHEDULER, 'RESET'].join('/'),
};

/**
 * @enum {String}
 */
export const TimeZoneStore = {
  SET_IS_AUTO_SYNC: [Reducers.TIME_ZONE_STORE, 'SET_IS_AUTO_SYNC'].join('/'),
  SET_GEO_AREA: [Reducers.TIME_ZONE_STORE, 'SET_GEO_AREA'].join('/'),
  SET_REGION: [Reducers.TIME_ZONE_STORE, 'SET_REGION'].join('/'),
  SET_DATE: [Reducers.TIME_ZONE_STORE, 'SET_DATE'].join('/'),
  SET_TIME: [Reducers.TIME_ZONE_STORE, 'SET_TIME'].join('/'),
  SET_ORIGIN: [Reducers.TIME_ZONE_STORE, 'SET_ORIGIN'].join('/'),
  SET_INIT: [Reducers.TIME_ZONE_STORE, 'SET_INIT'].join('/'),
  SET_TIMEZONE: [Reducers.TIME_ZONE_STORE, 'SET_TIMEZONE'].join('/'),
  RESET: [Reducers.TIME_ZONE_STORE, 'RESET'].join('/'),
};
